const cartContainer = document.querySelector('form[action="/cart"]'); // ou une autre div englobante du panier

if (cartContainer) {
  // Débounce : les mutations en rafale (nos propres mises à jour) ne doivent
  // déclencher qu'un seul recomptage
  let promoObsTimer;
  const observer = new MutationObserver(() => {
    clearTimeout(promoObsTimer);
    promoObsTimer = setTimeout(getPromoFilamentQty, 300);
  });

  observer.observe(cartContainer, {
    childList: true,
    subtree: true
  });
}




  // Tu peux relancer cette fonction à chaque mise à jour du panier
  // Exemple : écouter Shopify.Cart.events ou un bouton spécifique

function updatePromoFilamentMessage(qty) {
  let nextThreshold = 0;
  let currentDiscount = 0;
  let nextDiscount = 0;
  let message = "";

  if (qty < 2) {
    nextThreshold = 2;
    currentDiscount = 0;
    nextDiscount = 10;
  } 

  else if (qty < 3) {
    nextThreshold = 3;
    currentDiscount = 10;
    nextDiscount = 15;
  } 

   else if (qty < 4) {
    nextThreshold = 4;
    currentDiscount = 15;
    nextDiscount = 35;
  } 

  const delta = 4 - qty;
  const plural = delta > 1 ? "s" : "";

  if (qty >= 4) {
    message = `🎉 Vous profitez de notre <strong>remise exceptionelle de -35%</strong> sur tous vos filaments éligibles !`;
  } else if (qty >= 0) {
    if (currentDiscount === 0) {
      const delta3 = Math.max(1, 3 - qty);
      const plural3 = delta3 > 1 ? "s" : "";
      message = `🎯 Ajoutez ${delta3} bobine${plural3} et profitez de la 4ème à <strong><span data-fourth-marginal>${window.__fourthMarginalTxt || "quelques centimes"}</span></strong> de plus !`;
    } else {
      message = `👑 Débloquez le <strong>tarif VIP</strong> en rajoutant des bobines…`;
    }
  }

  const target = document.getElementById("promo-filament-message");
  if (target) target.innerHTML = `<h5>${message}</h5>`;

  // Timeline de paliers + suggestions du panier (présentes uniquement sur /cart)
  // La ligne démarre au bout de la langue de Yoshi, AVANT le jalon 1 : la jauge
  // parcourt d'abord la part fixe langue→jalon 1, puis 1/3 du reste par palier.
  // À 0 bobine la boule reste au bout de la langue (jauge à zéro).
  const fill = document.querySelector("[data-tier-fill]");
  if (fill) {
    const q = Math.min(qty, 4);
    let pct = 0;
    if (q > 0) {
      pct = ((q - 1) / 3) * 100;
      const line = fill.parentElement;
      const n1 = document.querySelector('.tier-node[data-tier-step="1"]');
      const lineRect = line ? line.getBoundingClientRect() : null;
      if (n1 && lineRect && lineRect.width > 0) {
        const n1Rect = n1.getBoundingClientRect();
        const r = Math.max(0, Math.min(1, (n1Rect.left + n1Rect.width / 2 - lineRect.left) / lineRect.width));
        pct = (r + ((q - 1) / 3) * (1 - r)) * 100;
      }
    }
    fill.style.width = pct + "%";
  }
  document.querySelectorAll("[data-tier-step]").forEach(function (el) {
    el.classList.toggle("hit", qty >= parseInt(el.dataset.tierStep, 10));
  });
  // Les suggestions restent visibles même une fois les -35 % atteints
  // (data-always-show = version panier vide, jamais masquée)
  const sugg = document.querySelector("[data-spool-suggestions]");
  if (sugg && !sugg.hasAttribute("data-always-show")) sugg.hidden = !(qty > 0);

  // Fiche produit : prix réellement payé pour CETTE bobine, en tenant compte
  // du panier actuel (paliers Discounty : 2→-10 %, 3→-15 %, 4→-35 %)
  updateRealPaid(qty);

  // Feu d'artifice quand on atteint les 4 bobines (une fois par franchissement)
  const widget = document.querySelector(".promo-tier-widget");
  if (widget) {
    const prevTier = parseInt(widget.dataset.lastQty || "0", 10);
    widget.dataset.lastQty = qty;
    if (qty >= 4 && prevTier > 0 && prevTier < 4) {
      launchTierFireworks(widget);
    }
  }
}

function updateRealPaid(cartQty) {
  const el = document.querySelector('[data-real-paid]');
  if (!el) return;
  const unitHt = parseInt(el.dataset.unitHt, 10);
  if (!unitHt) { el.innerHTML = ''; return; }
  const total = (cartQty || 0) + 1; // panier actuel + cette bobine
  const pct = total >= 4 ? 35 : total >= 3 ? 15 : total >= 2 ? 10 : 0;
  if (pct === 0) { el.innerHTML = ''; return; }
  const vf = window.vatFactor || 1.2;
  const paidTtc = (unitHt * (1 - pct / 100) * vf) / 100;
  const fmt = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });
  el.innerHTML = '💡 Avec votre panier, cette bobine vous revient à <b>' +
    fmt.format(paidTtc) + ' TTC</b> <span class="real-paid-pct">(−' + pct + ' % appliqué au panier)</span>';
}

function launchTierFireworks(container) {
  const colors = ["#FFA500", "#FF6347", "#2e9e4f", "#f3d054", "#130f32"];
  const origin = container.querySelector('[data-tier-step="4"] .tier-dot') || container;
  const rect = origin.getBoundingClientRect();
  const host = document.createElement("div");
  host.className = "tier-fireworks";
  host.style.left = rect.left + rect.width / 2 + "px";
  host.style.top = rect.top + rect.height / 2 + "px";
  document.body.appendChild(host);
  for (let i = 0; i < 26; i++) {
    const p = document.createElement("span");
    const ang = (Math.PI * 2 * i) / 26;
    const dist = 60 + (i % 5) * 18;
    p.style.setProperty("--dx", Math.cos(ang) * dist + "px");
    p.style.setProperty("--dy", Math.sin(ang) * dist + "px");
    p.style.background = colors[i % colors.length];
    host.appendChild(p);
  }
  setTimeout(function () {
    host.remove();
  }, 1300);
}

// Sonde de remise automatique : crée un panier JETABLE via l'API Storefront
// avec (q+1) bobines éligibles pour lire la remise RÉELLE du palier atteint,
// sans jamais toucher au vrai panier. Renvoie le taux (0–0.9) ou null.
// Robuste aux changements de règle Discounty : plus de % codé en dur.
async function detectNextTierRate(q) {
  try {
    const probeQty = Math.min((parseInt(q, 10) || 0) + 1, 12);
    const variant = window.PROMO_PROBE_VARIANT || "47709577609556"; // bobine éligible connue, publiée sur le canal
    const res = await fetch("/api/2023-07/graphql.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": "adde6f1fc1ea8ed4e530afa64cf59a25",
      },
      body: JSON.stringify({
        query:
          'mutation { cartCreate(input: { lines: [{ merchandiseId: "gid://shopify/ProductVariant/' +
          variant + '", quantity: ' + probeQty +
          ' }] }) { cart { cost { subtotalAmount { amount } totalAmount { amount } } } userErrors { message } } }',
      }),
    });
    const j = await res.json();
    const c = j && j.data && j.data.cartCreate && j.data.cartCreate.cart && j.data.cartCreate.cart.cost;
    if (!c) return null;
    const sub = parseFloat(c.subtotalAmount.amount);
    const tot = parseFloat(c.totalAmount.amount);
    if (!(sub > 0)) return null;
    return Math.max(0, Math.min(0.9, (sub - tot) / sub));
  } catch (e) {
    return null;
  }
}

// Coût marginal réel de la bobine Coupe du Monde : combien la commande
// augmente VRAIMENT en l'ajoutant, paliers Discounty recalculés sur tout
// le panier (2→−10 %, 3→−15 %, 4+→−35 %). Peut même être négatif.
function updateWorldcupMarginal(eligibleQty, items) {
  items = items || window.lastCartItems || [];
  const tier = (q) => (q >= 4 ? 0.35 : q === 3 ? 0.15 : q === 2 ? 0.10 : 0);
  let sumBase = 0;
  items.forEach((it) => {
    if (it.product_type === "Filament") sumBase += it.original_price * it.quantity;
  });
  const q = typeof eligibleQty === "number" ? eligibleQty : window.promoFilamentQty || 0;
  const vf = window.vatFactor || 1.2;
  const fmt = (c) => (Math.abs(c) / 100).toFixed(2).replace(".", ",") + " €";
  // Respecte le toggle TTC/HT et la TVA du pays sélectionné (window.vatFactor)
  const showTTC = typeof getToggleState === "function" ? getToggleState() : true;
  const lbl = showTTC ? "TTC" : "HT";
  const giftMsg = function (priceCents) {
    const oldT = sumBase * (1 - tier(q));
    const newT = (sumBase + priceCents) * (1 - tier(q + 1));
    const mHt = Math.round(newT - oldT);
    const m = showTTC ? Math.round(mHt * vf) : mHt;
    if (m <= 0) {
      return "🎁 En l'ajoutant à votre commande, votre total <strong>baisse même de " + fmt(m) + " " + lbl + "</strong> !";
    }
    return "🎁 Ce produit pour seulement <strong>" + fmt(m) + " " + lbl + "</strong> de plus sur votre commande";
  };
  // Deux logiques distinctes :
  //  • MESSAGE vs PRIX : < 4 bobines → message « ce produit pour seulement
  //    XX€ de plus » ; ≥ 4 (remise max acquise) → prix normal remisé.
  //  • BADGE −X % : remise débloquée en AJOUTANT une bobine = palier atteint
  //    à qty+1 (1→0, 2→10, 3→15, 4+→35). Panier à 2 bobines → badge −15 %,
  //    à 3 bobines → −35 %. Affiché à tous les paliers où l'ajout remise.
  const atMax = q >= 4;
  // % débloqué en ajoutant 1 bobine : taux RÉEL sondé (Storefront) s'il est
  // disponible pour CE palier, sinon repli sur la règle des paliers connue.
  const nextRate = (typeof window.promoNextRate === "number" && window.promoNextRateQty === q)
    ? window.promoNextRate
    : tier(q + 1);
  const nextPct = Math.round(nextRate * 100);
  const applyBadge = function (rowEl) {
    if (!rowEl) return;
    if (nextPct > 0) { rowEl.classList.add("at-discount"); rowEl.dataset.discountPct = nextPct; }
    else { rowEl.classList.remove("at-discount"); delete rowEl.dataset.discountPct; }
  };
  // Prix normal remisé (palier max −35 %), toggle HT/TTC + TVA pays respectés
  const renderPromoPrice = function (priceSpan, fullCents, pct) {
    if (!priceSpan) return;
    const promoHt = Math.round(fullCents * (1 - pct / 100));
    const conv = function (c) { return formatPrice((showTTC ? c * vf : c) / 100); };
    const ttc = showTTC ? "true" : "false";
    priceSpan.innerHTML =
      '<span class="yv-product-price spool-price-promo" data-ttc="' + ttc + '"><span class="dualPrice">' + conv(promoHt) + "</span></span>" +
      '<span class="spool-price-promo-label">avec −' + pct + "&nbsp;%</span>" +
      '<span class="yv-product-compare-price" data-ttc="' + ttc + '"><span class="dualPrice">' + conv(fullCents) + "</span></span>";
  };
  // Carte Coupe du Monde : masquée si déjà au panier, sinon message/prix + badge
  const el = document.querySelector("[data-wc-marginal]");
  if (el) {
    const wcRow = el.closest(".hot-sale-row.worldcup");
    const wcInCart = items.some((it) => it.handle === "pla-silk-or-premium-wanhao-1kg-3");
    if (wcRow) wcRow.style.display = wcInCart ? "none" : "";
    const wcPrice = parseInt(el.getAttribute("data-wc-price"), 10) || 0;
    const wcPriceSpan = wcRow ? wcRow.querySelector(".wc-price") : null;
    if (!wcInCart && wcPrice) {
      if (atMax) {
        renderPromoPrice(wcPriceSpan, wcPrice, nextPct);
        if (wcPriceSpan) wcPriceSpan.style.display = "";
        el.hidden = true;
      } else {
        el.innerHTML = giftMsg(wcPrice);
        el.hidden = false;
        if (wcPriceSpan) wcPriceSpan.style.display = "none";
      }
      applyBadge(wcRow);
    }
  }
  // Bobines proposées : message « ce produit pour XX€ de plus » (< 4) ou prix
  // remisé (≥ 4), badge −X % dynamique dans les deux cas
  let meilleurPrix = Infinity;
  document.querySelectorAll("[data-spool-marginal]").forEach((sm) => {
    if (sm.closest(".reel-strip")) return; // clones transitoires de la roulette
    const p = parseInt(sm.getAttribute("data-price"), 10) || 0;
    if (!p) return;
    if (p < meilleurPrix) meilleurPrix = p;
    const row = sm.closest(".spool-suggest-row");
    const priceSpan = sm.parentElement.querySelector(".spool-suggest-price");
    if (atMax) {
      renderPromoPrice(priceSpan, p, nextPct);
      if (priceSpan) priceSpan.style.display = "";
      sm.hidden = true;
    } else {
      sm.innerHTML = giftMsg(p);
      sm.hidden = false;
      if (priceSpan) priceSpan.style.display = "none";
    }
    applyBadge(row);
  });
  // Jalon 1 : coût réel de la prochaine bobine, calé sur le meilleur prix
  // du tableau de remises, recalculé en temps réel
  const lbl1 = document.querySelector('.tier-node[data-tier-step="1"] .tier-label b');
  if (lbl1 && isFinite(meilleurPrix)) {
    const oT = sumBase * (1 - tier(q));
    const nT = (sumBase + meilleurPrix) * (1 - tier(q + 1));
    const mHt1 = Math.round(nT - oT);
    const m1 = showTTC ? Math.round(mHt1 * vf) : mHt1;
    lbl1.innerHTML = "Ajoutez 1 bobine pour seulement " + fmt(m1) + " " + lbl;
  }
  // Bandeau : coût réel de la 4ᵉ bobine — panier complété à 3 bobines au
  // meilleur prix, puis passage 3→4 (−15 % → −35 % sur tout)
  if (isFinite(meilleurPrix)) {
    const s3 = sumBase + Math.max(0, 3 - q) * meilleurPrix;
    const mHt4 = Math.round((s3 + meilleurPrix) * (1 - tier(4)) - s3 * (1 - tier(3)));
    const m4 = showTTC ? Math.round(mHt4 * vf) : mHt4;
    window.__fourthMarginalTxt = m4 <= 0 ? "0 €" : fmt(m4) + " " + lbl;
    const fm = document.querySelector("[data-fourth-marginal]");
    if (fm) fm.textContent = window.__fourthMarginalTxt;
  }
}

async function getPromoFilamentQty() {
    // Jeton de séquence : une réponse périmée (appel plus ancien qui finit après)
    // ne doit jamais écraser un état plus récent — c'était la cause du
    // « ça monte, ça redescend, ça remonte » sur la timeline.
    const seq = (getPromoFilamentQty._seq = (getPromoFilamentQty._seq || 0) + 1);
    // Gel total tant qu'une modification est en attente : fenêtre de debounce
    // (avant l'appel API) OU requête en vol. L'état local (optimiste) fait foi
    // jusqu'à la validation — c'était la cause du yo-yo de la timeline.
    const promoFrozen = () =>
      window.cartMutationPending > 0 ||
      (typeof window.hasPendingCartChanges === 'function' && window.hasPendingCartChanges());
    if (promoFrozen()) return;
    try {
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      if (promoFrozen()) return;

      const items = cart.items;
      const eligibleHandles = [];

      for (const item of items) {
        if (item.product_type === 'Filament') {
          eligibleHandles.push(item.handle);
        }
      }

      window.lastCartItems = items;

      if (eligibleHandles.length === 0) {
        if (seq !== getPromoFilamentQty._seq) return;
        window.promoFilamentQty = 0;
        updatePromoFilamentMessage(0);
        updateWorldcupMarginal(0, items);
        return;
      }

      const query = `
        query getProductsByHandle {
          ${eligibleHandles
            .map(
              (handle, index) => `
            product${index}: productByHandle(handle: "${handle}") {
              handle
              metafield(namespace: "custom", key: "eligible_code_promo") {
                value
              }
            }
          `
            )
            .join('\n')}
        }`;

      const res = await fetch('/api/2023-07/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': 'adde6f1fc1ea8ed4e530afa64cf59a25',
        },
        body: JSON.stringify({ query }),
      });

      const data = await res.json();

      // La réponse GraphQL est indexée par position dans eligibleHandles,
      // PAS par position dans le panier : table handle → éligibilité, sinon
      // un panier mixte (accessoire + bobines) fausse tout le comptage.
      const eligByHandle = {};
      eligibleHandles.forEach((h, idx) => {
        const pd = data.data[`product${idx}`];
        eligByHandle[h] = pd?.metafield?.value === 'true';
      });
      let totalQty = 0;
      for (const item of items) {
        if (item.product_type === 'Filament' && eligByHandle[item.handle]) {
          totalQty += item.quantity;
        }
      }
      if (seq !== getPromoFilamentQty._seq) return;
      if (promoFrozen()) return;
      updateWorldcupMarginal(totalQty, items);
      // Sonde NON bloquante : lit la remise réelle du prochain palier et
      // rafraîchit l'affichage (le taux ne s'applique qu'au palier sondé).
      // On ne sonde QUE si le palier a changé (évite les appels API redondants).
      if (window.promoNextRateQty !== totalQty) {
        detectNextTierRate(totalQty).then(function (rate) {
          if (rate == null) return;
          window.promoNextRate = rate;
          window.promoNextRateQty = totalQty;
          updateWorldcupMarginal(totalQty, window.lastCartItems || items);
        });
      }
      // Ne bouger QUE s'il y a un écart entre l'état local et le retour API
      if (totalQty === window.promoFilamentQty) return;
      updatePromoFilamentMessage(totalQty);
      window.promoFilamentQty = totalQty;
      console.log("✅ Quantité dynamique de filaments éligibles :", window.promoFilamentQty);

    } catch (error) {
      console.error("Erreur lors du comptage dynamique des filaments :", error);
    }
  }


getPromoFilamentQty();
//ajout mini bouton panier dynamique
  document.addEventListener("DOMContentLoaded", function () {
    // Cible les boutons upsell
    document.querySelectorAll('button[data-upsell]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const productId = btn.getAttribute('data-product-id');

        if (!productId) return;

        // Affiche un loader si besoin
        const loader = btn.querySelector('.svg-loader');
        if (loader) loader.style.display = 'block';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: productId,
            quantity: 1
          })
        })
        .then(response => {
          if (!response.ok) throw new Error('Erreur ajout au panier');
          return response.json();
        })
        .then(data => {
          // Recharge partielle du mini-panier ou du panier complet selon ton besoin
          return fetch('/cart?view=ajax');
        })
        .then(response => response.text())
        .then(html => {
          // Remplace le contenu du panier (tu peux adapter ce sélecteur à ton thème)
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newCart = doc.querySelector('.cart-page');
          const currentCart = document.querySelector('.cart-page');
          if (newCart && currentCart) currentCart.innerHTML = newCart.innerHTML;
        })
        .catch(error => {
          console.error(error);
          alert('Erreur lors de l’ajout au panier 0');
        })
        .finally(() => {
          if (loader) loader.style.display = 'none';
        });
      });
    });
  });

//Fonction HT / TTC

const porcentajeTTC = (typeof window.vatRate === 'number' ? window.vatRate : 20) / 100;

function getToggleState(){
  return JSON.parse(localStorage.getItem('showTTC') || 'true');
}

function saveToggleState(state){
  localStorage.setItem('showTTC', JSON.stringify(state));
}

function parsePrice(str) {
  if (!str) return NaN;
  
  return parseFloat(
    str
      .toString()
      .replace(/\s/g, '')        // supprime espaces
      .replace(/\u00A0/g, '')    // supprime espaces insécables
      .replace(/\./g, '')        // supprime points (milliers)
      .replace(',', '.')         // virgule → point décimal
  );
}


function formatPrice(euros) {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR'
  }).format(euros);
}

// Exemples :
console.log(formatPrice(9500));      // "9 500,00 €"
console.log(formatPrice(1299.99));   // "1 299,99 €"
function applyConversion(element, showTTCInput) {
  console.log('🔍 [applyConversion] Démarrage pour élément :', element);
  let showTTC = showTTCInput;
  if (element.closest('.Pricecadeau')) {
    showTTC = false;
    console.log('🔒 Bloc Pricecadeau détecté → forçage en HT');
  }
    // Étape 1 : recherche de l'élément .dualPrice
  const dual = element.querySelector ? element.querySelector('.dualPrice') : null;

  if (!dual) {
    console.warn('⛔ .dualPrice introuvable dans :', element);
    return;
  }
  console.log('✅ .dualPrice trouvé :', dual);

  // Étape 2 : récupération du prix actuel sous forme de texte
  const currentText = dual.textContent.trim();
  console.log('📥 Texte brut du prix :', currentText);

  // Étape 3 : conversion en float
  const current = parsePrice(currentText);
  if (isNaN(current)) {
    console.error('❌ Impossible de parser le prix :', currentText);
    return;
  }
  console.log('💶 Prix numérique parsé :', current);

  // Étape 4 : vérifie si l'élément est déjà en TTC
  const hasTTC = element.getAttribute('data-ttc') === 'true';
  console.log(`📌 data-ttc actuel : ${hasTTC}, showTTC demandé : ${showTTC}`);

  // Étape 5 : conversion du prix si nécessaire
  let price = current;

  if (showTTC && !hasTTC) {
    price = current * (1 + porcentajeTTC);
    element.setAttribute('data-ttc', 'true');
    console.log(`🔁 Conversion HT → TTC : ${current} → ${price}`);
  } else if (!showTTC && hasTTC) {
    price = current / (1 + porcentajeTTC);
    element.setAttribute('data-ttc', 'false');
    console.log(`🔁 Conversion TTC → HT : ${current} → ${price}`);
  } else {
    console.log('✅ Pas de conversion : le prix est déjà au bon format');
  }

  // Étape 6 : mise à jour du texte affiché
  const formatted = formatPrice(price);
  dual.textContent = formatted;
  console.log('📝 Nouveau prix affiché :', formatted);
}

function updateAllPrices(){
  const showTTC = getToggleState();
  console.log(`🔁 updateAllPrices() lancé - Affichage ${showTTC ? 'TTC' : 'HT'}`);
  const selectors = '.yv-spotlight-product-price, .yv-product-price, .yv-product-compare-price';
  const elements = document.querySelectorAll(selectors);
  console.log(`🔎 ${elements.length} éléments trouvés pour mise à jour des prix`);
  elements.forEach((el, index) => {
    console.log(`👉 Élément #${index + 1}:`, el);
    applyConversion(el, showTTC);
  });
}


// Surveille toute modification du DOM
const observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    mutation.addedNodes.forEach(node => {
      if (!(node instanceof Element)) return;

      // Vérifie si le Quick View vient d'être ajouté
      if (node.id === 'product-quick-view' ||
          node.matches('.yv-quickview_product_wrapper')) {


        // Attendre un peu avant de mettre à jour les prix
        setTimeout(() => {
          updateAllPrices();
          console.log('🔄 updateAllPrices() exécuté après Quick View');
        }, 50);
      }
    });
  });
});

// Observe les ajouts dans tout le body
observer.observe(document.body, {
  childList: true,
  subtree: true
});

document.addEventListener('DOMContentLoaded', ()=>{
  const btn = document.getElementById('togglePreciosBtn');
  if(!btn) return;

  const toggleStyles = ()=>{
    const showTTC = getToggleState();
    btn.innerText = showTTC ? 'TTC' : 'HT';
    document.querySelector('.toggle-container')?.classList.toggle('active', !showTTC);
    // Doubles prix : le toggle n'inverse que l'emphase visuelle (grand/petit)
    document.body.classList.toggle('vat-mode-ht', !showTTC);
  };

  btn.addEventListener('click', ()=>{
    const newState = !getToggleState();
    saveToggleState(newState);
    toggleStyles();
    updateAllPrices();
    // Lignes cadeau des produits de complément : re-rendues dans le bon mode
    if (typeof updateWorldcupMarginal === 'function') updateWorldcupMarginal();
  });

  toggleStyles();
  updateAllPrices();
});

// [✅] Surveille lorsque le quick view est ouvert
document.addEventListener('quickview:open', function(evt) {
  console.log('📦 quickview:open detected', evt.detail);
});

// [✅] Surveille lorsque le contenu du quick view est entièrement chargé
document.addEventListener('quickview:loaded', function(evt) {
  console.log('✅ quickview:loaded detected', evt.detail);

  // Petite pause pour laisser le DOM se stabiliser
  setTimeout(() => {
    updateAllPrices(); // Recalcule les prix HT/TTC
  }, 50);
});

document.addEventListener('DOMContentLoaded', () => {
  const showTTC = getToggleState();

  function initProductPagePrices() {
    document.querySelectorAll('.dualPrice').forEach(el => {
      let parent = el.closest('[data-ttc]') || el.parentElement;
      parent.setAttribute('data-ttc', showTTC ? 'true' : 'false');
    });
    updateAllPrices(); // Recalcule les prix une fois l'attribut bien posé
  }

  // Retarde l'exécution pour laisser le DOM se stabiliser (produit Yuva)
  setTimeout(() => {
    if (document.querySelector('.product__info-container')) {
      initProductPagePrices();
    }
  }, 200); // Ajuste ce délai si nécessaire (200 à 500ms)
});
// Le total TTC du panier est géré par sections/main-cart.liquid — ne pas le réappliquer ici.



try {
  const elementsToClick = document.querySelectorAll('.AirReviews-Widget--Stars');

  elementsToClick.forEach((element) => {
    element.addEventListener('click', () => {
      const elementToScroll = document.getElementById('AirReviews-BlockWrapper');
      elementToScroll.scrollIntoView({ behavior: 'smooth' });
    });
  });
} catch (error) {
  console.error('An error occurred:', error);
}


// Spinner

function showSpinner() {
  const spinnerContainer = document.getElementById('spinner-container');
  if (spinnerContainer) {
    spinnerContainer.style.display = 'flex';
  }
}

function hideSpinner() {
  const spinnerContainer = document.getElementById('spinner-container');
  if (spinnerContainer) {
    spinnerContainer.style.display = 'none';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('pay-credit-element');
  const productPrice = document.querySelector('.yv-spotlight-product-price','.yv-product-price .dualPrice');

  const iconInfo = document.getElementById('info_button');
  if (!container || !iconInfo) return;
  const beforeElement = document.createElement('div');
  beforeElement.className = 'info-card';
  beforeElement.style.opacity = '0';

  iconInfo.addEventListener('click', () => {
    if (container && productPrice) {
      const priceText = productPrice.textContent;
      const priceValue = parseFloat(priceText.replace('€', '').replace(',', '.'));
      if (!isNaN(priceValue)) {
        const installmentPrice = (priceValue / 4).toFixed(2);
        beforeElement.textContent = `Initial Payment: €${installmentPrice}\n
          Second Payment: €${installmentPrice}\n
          Third Payment: €${installmentPrice}\n
          Fourth Payment: €${installmentPrice}`;
        beforeElement.style.opacity = '1';
      }
    }
  });

  iconInfo.addEventListener('mouseenter', () => {
    if (container && productPrice) {
      const priceText = productPrice.textContent;
      const priceValue = parseFloat(priceText.replace('€', '').replace(',', '.'));
      if (!isNaN(priceValue)) {
        const installmentPrice = (priceValue / 4).toFixed(2);
        beforeElement.textContent = `Initial Payment: €${installmentPrice}\n
          Second Payment: €${installmentPrice}\n
          Third Payment: €${installmentPrice}\n
          Fourth Payment: €${installmentPrice}`;
        beforeElement.style.opacity = '1';
      }
    }
  });

  iconInfo.addEventListener('mouseleave', () => {
    beforeElement.style.opacity = '0';
  });

  container.appendChild(beforeElement);
});

/*function getLocalStorageValue(key) {
  let localStorageValue = localStorage.getItem(key);
  let parsedValue = JSON.parse(localStorageValue);

  return parsedValue;
}

let showTTCValue = getLocalStorageValue('showTTC');
let porcentajeTTC = 0.2;

// Toggle Button
document.addEventListener('DOMContentLoaded', function () {
  const togglePricesBtn = document.getElementById('togglePreciosBtn');
  const toggleContainer = document.querySelector('.toggle-container');

  let showTTC = getToggleState();

  function saveToggleState(state) {
    localStorage.setItem('showTTC', JSON.stringify(state));
  }

  function getToggleState() {
    const savedState = localStorage.getItem('showTTC');
    return savedState !== null ? JSON.parse(savedState) : true;
  }

  function updateStyles() {
    if (showTTC) {
      toggleContainer.classList.remove('active');
      togglePricesBtn.innerText = 'TTC';
    } else {
      toggleContainer.classList.add('active');
      togglePricesBtn.innerText = 'HT';
    }
  }

  function handleToggleClick() {

    showSpinner();

    showTTC = !showTTC;
    saveToggleState(showTTC);
    updateStyles();

    const toggleChangeEvent = new CustomEvent('toggleStateChanged', { detail: { showTTC } });
    document.dispatchEvent(toggleChangeEvent);

    location.reload();
  }

  togglePricesBtn.addEventListener('click', handleToggleCliapplck);

  updateStyles();
});

// TTC Functionality

function modifyElement(element, showTTC) {
  const dualPriceElement = element.querySelector('.yv-product-price .dualPrice');

  if (dualPriceElement) {
    let ttcProperty = element.getAttribute('ttc');
    if (ttcProperty !== 'true' && showTTC) {
      let currentPrice = getPrice(dualPriceElement.textContent);

      if (!ttcProperty) {
        let newPrice = currentPrice + (currentPrice * porcentajeTTC);

        dualPriceElement.textContent = formatPrice(newPrice) + '€';


        ttcProperty = 'true';
        element.setAttribute('ttc', ttcProperty);
      }
    }
  }
}

function getPrice(textPrice) {
  return parseFloat(textPrice.replace(/[^\d,]/g, '').replace(',', '.'));
}

function formatPrice(price) {
  return price.toFixed(2).replace('.', ',');
}

const observerConfig = {
  threshold: 0.5,
};

function handleIntersection(entries, observer) {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      modifyElement(entry.target);
    }
  });
}

const observer = new IntersectionObserver(handleIntersection, observerConfig);

const observedElements = document.querySelectorAll('.yv-product-price');

observedElements.forEach(element => {
  observer.observe(element);
});
console.log('Appel de handleScroll avec showTTC =', showTTC);
function handleScroll(showTTC) {
  const elements = document.querySelectorAll('.yv-product-price');

  elements.forEach(element => {
    modifyElement(element, showTTC);
  });
}

function init() {
  const togglePricesBtn = document.getElementById('togglePreciosBtn');

  function saveToggleState(state) {
    localStorage.setItem('showTTC', JSON.stringify(state));
  }

  function getToggleState() {
    const savedState = localStorage.getItem('showTTC');
    return savedState ? JSON.parse(savedState) : false;
  }

  function updateStateAndToggleText() {
    const showTTC = !getToggleState();
    saveToggleState(showTTC);
    togglePricesBtn.innerText = showTTC ? 'TTC' : 'HT';
    handleScroll(showTTC);
  }

  togglePricesBtn.addEventListener('click', updateStateAndToggleText);

  const showTTCOnLoad = getToggleState();
  togglePricesBtn.innerText = showTTCOnLoad ? 'TTC' : 'HT';

  handleScroll(showTTCOnLoad);

  window.addEventListener('scroll', () => {
    const showTTC = getToggleState();
    handleScroll(showTTC);
  });
}
init();

function actualizarPrecios() {
  let showTTCValue = getLocalStorageValue('showTTC');

  if (showTTCValue === true) {
    let parentElements = document.querySelectorAll('.yv-product-compare-price');

    parentElements.forEach(function (parentElement) {
      if (!parentElement.classList.contains('actualizado')) {
        if (!parentElement.classList.contains('no-actualizar')) {
          let elementsHijos = parentElement.querySelectorAll('.dualPrice');
          elementsHijos.forEach(function (elementHijo) {
            if (!elementHijo.classList.contains('actualizado')) {
              let textoActual = elementHijo.textContent;
              let valorNumerico = parseFloat(textoActual.replace(/[^\d,.-]/g, '').replace(',', '').replace('.', '').replace('-', '.'));
              let nuevoValor = valorNumerico + (valorNumerico * porcentajeTTC);
              let valorFinal = nuevoValor / 100;
              let nuevoTexto = '€' + valorFinal.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

              elementHijo.textContent = nuevoTexto;

              elementHijo.classList.add('actualizado');
            }
          });

          parentElement.classList.add('actualizado');
        }
      }
    });
  }
}

window.addEventListener('scroll', actualizarPrecios);

actualizarPrecios();

window.addEventListener('storage', function (event) {
  if (event.key === 'showTTC') {
    actualizarPrecios();
  }
});
/*
function modifierTotalPanier() {
  let showTTCValue = getLocalStorageValue('showTTC');
  let totalWrapper = document.querySelector('.cart-total-item .dualPrice');

  if (showTTCValue && totalWrapper) {
    const spanPrice = totalWrapper.querySelector('.dualPrice');
    let rawDataPrice = totalWrapper.getAttribute('data-price');

    if (spanPrice && rawDataPrice && !spanPrice.classList.contains('actualizado')) {
      let prix = parseFloat(rawDataPrice);
      let prixTTC = prix * (1 + porcentajeTTC);

      let texteTTC = '€' + prixTTC.toLocaleString('fr-FR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });

      spanPrice.textContent = texteTTC;
      spanPrice.classList.add('actualizado');

      const label = document.querySelector('.cart-total-item p');
      if (label) label.textContent = 'Total TTC';
    }
  }
}

function modifierTotalPanierDrawer() {
  let showTTCValue = getLocalStorageValue('showTTC');
  let drawerTotal = document.querySelector('.drawer__footer .dualPrice');

  if (showTTCValue && drawerTotal && !drawerTotal.classList.contains('actualizado')) {
    let rawPrice = drawerTotal.getAttribute('data-price');

    if (rawPrice) {
      let prix = parseFloat(rawPrice);
      let prixTTC = prix * (1 + porcentajeTTC);

      drawerTotal.textContent = '€' + prixTTC.toLocaleString('fr-FR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });

      drawerTotal.classList.add('actualizado');

      const label = document.querySelector('.drawer__footer .totals__subtotal');
      if (label) label.textContent = 'Total TTC';
    }
  }
}

const observerDrawer = new MutationObserver(function (mutations) {
  for (const mutation of mutations) {
    if (mutation.addedNodes.length) {
      const drawerCart = document.querySelector('.cart-drawer'); // adapte ce sélecteur si besoin
      if (drawerCart) {
        console.log('Tiroir détecté, mise à jour des prix HT/TTC');

        // Re-appliquer les prix dans le tiroir
        actualizarPrecios();
        modifierTotalPanier();
      }
    }
  }
});

observerDrawer.observe(document.body, {
  childList: true,
  subtree: true,
});
*/
/*
window.addEventListener('storage', function (event) {
  if (event.key === 'showTTC') {
    actualizarPrecios();
    modifierTotalPanier();
  }
});

//TTC Cart/Controller

document.addEventListener('DOMContentLoaded', function () {
  let dualPriceElement = document.querySelector('.list-unstyled.cart-total-list .cart-total-item.text-large .h2 .dualPrice');

  if (dualPriceElement && dualPriceElement.innerHTML) {
    let num = dualPriceElement.innerHTML
      .replace('€', '')
      .replace('.', '')
      .replace(',', '.');

    if (showTTC === 'true') {
      num *= (1 + porcentajeTTC);
    }

    let totalAmount = parseFloat(num);
    dualPriceElement.textContent = '€' + totalAmount.toFixed(2);

    let totalElement = document.querySelector('.cart-total-item p');
    if (totalElement) {
      totalElement.textContent = 'Total ' + (showTTC === 'true' ? 'TTC' : 'HT');
    }
  } else {
    console.warn("Élément .dualPrice introuvable ou vide.");
  }
});



try {
  const elementsToClick = document.querySelectorAll('.AirReviews-Widget--Stars');

  elementsToClick.forEach((element) => {
    element.addEventListener('click', () => {
      const elementToScroll = document.getElementById('AirReviews-BlockWrapper');
      elementToScroll.scrollIntoView({ behavior: 'smooth' });
    });
  });
} catch (error) {
  console.error('An error occurred:', error);
}
*/
/*
console.log('Valeur de showTTC au chargement :', getLocalStorageValue('showTTC'));
document.addEventListener('DOMContentLoaded', function () {
  setTimeout(() => {
    let stored = localStorage.getItem('showTTC');
    let showTTC = stored !== null ? JSON.parse(stored) : true;

    console.log('Forçage mise à jour tiroir avec showTTC =', showTTC);
    handleScroll(showTTC);
  }, 1000);
});
*/
// Spinner
/*
function showSpinner() {
  const spinnerContainer = document.getElementById('spinner-container');
  if (spinnerContainer) {
    spinnerContainer.style.display = 'flex';
  }
}

function hideSpinner() {
  const spinnerContainer = document.getElementById('spinner-container');
  if (spinnerContainer) {
    spinnerContainer.style.display = 'none';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('pay-credit-element');
  const productPrice = document.querySelector('.yv-product-price .dualPrice');

  const iconInfo = document.getElementById('info_button');
  const beforeElement = document.createElement('div');
  beforeElement.className = 'info-card';
  beforeElement.style.opacity = '0';

  iconInfo.addEventListener('click', () => {
    if (container && productPrice) {
      const priceText = productPrice.textContent;
      const priceValue = parseFloat(priceText.replace('€', '').replace(',', '.'));
      if (!isNaN(priceValue)) {
        const installmentPrice = (priceValue / 4).toFixed(2);
        beforeElement.textContent = `Initial Payment: €${installmentPrice}\n
          Second Payment: €${installmentPrice}\n
          Third Payment: €${installmentPrice}\n
          Fourth Payment: €${installmentPrice}`;
        beforeElement.style.opacity = '1';
      }
    }
  });

  iconInfo.addEventListener('mouseenter', () => {
    if (container && productPrice) {
      const priceText = productPrice.textContent;
      const priceValue = parseFloat(priceText.replace('€', '').replace(',', '.'));
      if (!isNaN(priceValue)) {
        const installmentPrice = (priceValue / 4).toFixed(2);
        beforeElement.textContent = `Initial Payment: €${installmentPrice}\n
          Second Payment: €${installmentPrice}\n
          Third Payment: €${installmentPrice}\n
          Fourth Payment: €${installmentPrice}`;
        beforeElement.style.opacity = '1';
      }
    }
  });

  iconInfo.addEventListener('mouseleave', () => {
    beforeElement.style.opacity = '0';
  });

  container.appendChild(beforeElement);
});
*/ 
// Box pay in 4X/3X Animation 
/*
document.addEventListener('DOMContentLoaded', function () {
  const container = document.getElementById('pay-credit-element');
  const productPrice = document.querySelector('.yv-product-price .dualPrice');

  if (container && productPrice) {
    const beforeElement = document.createElement('div');
    beforeElement.className = 'info-card';
    beforeElement.style.opacity = '0';
    const priceText = productPrice.textContent;
    const priceValue = parseFloat(priceText.replace('€', '').replace(',', '.'));

    if (!isNaN(priceValue)) {
      const installmentPrice = (priceValue / 4).toFixed(2);

      container.appendChild(beforeElement);

      container.addEventListener('mouseenter', function () {
        beforeElement.textContent = `Initial Payment: €${installmentPrice}\n
          Second Payment: €${installmentPrice}\n
          Third Payment: €${installmentPrice}\n
          Fourth Payment: €${installmentPrice}`;
        beforeElement.style.opacity = '1';
        container.querySelector('.info-text').style.opacity = '0';
      });

      container.addEventListener('mouseleave', function () {
        beforeElement.textContent = '';
        beforeElement.style.opacity = '0';
        container.querySelector('.info-text').style.opacity = '1';
      });
    }
  }
}); */

function hideIfSingleChildWithSingleLi(selector) {
  document.querySelectorAll(selector).forEach(function (element) {

    let ulChildren = element.querySelectorAll('ul');
    if (ulChildren.length === 1 && ulChildren[0].parentNode === element) {

      let liChildren = ulChildren[0].querySelectorAll('li');
      if (liChildren.length === 1 && liChildren[0].parentNode === ulChildren[0]) {

        element.style.display = 'none';
      }
    }
  });
}

hideIfSingleChildWithSingleLi('.select-couleur');
hideIfSingleChildWithSingleLi('.select-material');
hideIfSingleChildWithSingleLi('.select-poids');
hideIfSingleChildWithSingleLi('.select-style');
hideIfSingleChildWithSingleLi('.select-titulo');

document.addEventListener('DOMContentLoaded', function timeNotification() {
  const container = document.getElementById('notification-container');
  if (!container) return;

  // Initialisation des éléments de notification
  let notification = document.createElement('div');
  notification.id = 'custom-notification';
  notification.className = 'notification info';
  let messageContent = document.createElement('div');
  messageContent.className = 'message-content notranslate';
  let countdownElement = document.createElement('span');
  countdownElement.className = 'countdown countdown-red notranslate';

  container.appendChild(notification);
  notification.appendChild(messageContent);
  notification.appendChild(countdownElement);

  // Initialisation du message de base
  function initBaseMessage() {
    const currentTime = new Date();
    if (currentTime.getDay() >= 1 && currentTime.getDay() <= 5 && currentTime.getHours() < 13) {
      messageContent.innerHTML = "Garantie d'expédition aujourd'hui, plus que ";
    } else if ((currentTime.getDay() >= 1 && currentTime.getDay() <= 4 && currentTime.getHours() >= 13) || currentTime.getDay() === 1) {
      messageContent.innerHTML = "Garantie d'expédition demain, plus que ";
    } else {
      messageContent.innerHTML = "Garantie d'expédition lundi, plus que ";
    }
  }

  function formatTime(time) {
    return time < 10 ? `0${time}` : `${time}`;
  }

  function timeRemaining(expirationTime, currentTime) {
    const timeTo = (expirationTime - currentTime) / 1000;
    const hoursRemaining = Math.floor(timeTo / 3600);
    const minutesRemaining = Math.floor((timeTo % 3600) / 60);
    const secondsRemaining = Math.floor(timeTo % 60);
    return { hoursRemaining, minutesRemaining, secondsRemaining };
  }

  function updateCountdown() {
    const currentTime = new Date();
    let expirationTime = new Date(currentTime);
    if (currentTime.getDay() >= 1 && currentTime.getDay() <= 5 && currentTime.getHours() < 13) {
      expirationTime.setHours(13, 0, 0, 0);
    } else if ((currentTime.getDay() >= 1 && currentTime.getDay() <= 4 && currentTime.getHours() >= 13) || currentTime.getDay() === 1) {
      expirationTime.setDate(currentTime.getDate() + 1);
      expirationTime.setHours(13, 0, 0, 0);
    } else {
      const daysToMonday = (8 - currentTime.getDay()) % 7;
      expirationTime.setDate(currentTime.getDate() + daysToMonday);
      expirationTime.setHours(13, 0, 0, 0);
    }

    let timeFormat = timeRemaining(expirationTime, currentTime);
    countdownElement.innerHTML = `${formatTime(timeFormat.hoursRemaining)}h${formatTime(timeFormat.minutesRemaining)}m${formatTime(timeFormat.secondsRemaining)}s`;
  }

  initBaseMessage();
  setInterval(updateCountdown, 1000);
});



const containerDelivery = document.querySelector('.container-delivery');

function getDeliveryMessage() {
  const currentTime = new Date();
  const currentDay = currentTime.getDay();
  const currentHour = currentTime.getHours();

  let deliveryMessage;

  
  if ((currentDay >= 1 && currentDay <= 5 && currentHour < 13)) {
    deliveryMessage = " Expédié aujourd’hui";
  } else if ((currentDay >= 1 && currentDay <= 4 && currentHour >= 13) || currentDay === 0) {
    deliveryMessage = " Expédié demain matin";
  } else {
    deliveryMessage = " Expédié lundi matin";
  }
  return deliveryMessage;
}
const deliveryMessage = getDeliveryMessage();
const deliveryMessageEl = document.querySelector('.delivery-info__message');
if (deliveryMessage && deliveryMessageEl) {
  deliveryMessageEl.textContent = deliveryMessage;
  const deliveryLogoDiv = document.querySelector('.delivery-info__logo');
  /* const img = document.createElement('img');
  img.src = 'https://i.ibb.co/wpXqVsR/logo-delivery.png';
  deliveryLogoDiv.appendChild(img); */
}
const walletContainer = document.querySelector('.wallet__reward')
let rewardCounter = document.querySelector('.reward')
if (walletContainer && rewardCounter) {
  const imgWallet = document.createElement('img');
  imgWallet.setAttribute('src', 'https://i.ibb.co/94WDtLZ/reward.png')
  walletContainer.appendChild(imgWallet)

  // Le prix principal est passé au double affichage TTC/HT : on lit le HT
  // du nouveau bloc (ancien sélecteur en secours), puis 5 % du TTC.
  if (rewardCounter.innerHTML === '') {
    const src =
      document.querySelector('.price-dual-main .price-ht .amt') ||
      document.querySelector('.yv-product-price.h2 .dualPrice') ||
      document.querySelector('.yv-product-price .dualPrice');
    if (src) {
      const ht = parseFloat((src.textContent || '').replace(/\D/g, '')) / 100;
      const ttc = ht * (window.vatFactor || 1.2);
      if (ttc > 0) {
        rewardCounter.innerHTML = `+${(ttc * 0.05).toFixed(2)}€ sur votre cagnotte en achetant ce produit.`;
      }
    }
  }
}



/*document.addEventListener('DOMContentLoaded', function () {
  const productElement = document.querySelector('#product');
  const optionSelectors = productElement.querySelectorAll('.optionValueSelectors input');
  optionSelectors.forEach(input => {
    input.addEventListener('change', function (event) {
      const productWrapper = event.target.closest('#product');
      const sectionId = productWrapper.dataset.sectionId;
      const oldProductUrl = productWrapper.dataset.productUrl;
      const newProductUrl = event.target.dataset.productUrl;

      fetch(`${newProductUrl}?section_id=${sectionId}`)
        .then(r => r.text())
        .then(htmlText => {
          const html = new DOMParser().parseFromString(htmlText, 'text/html');
          const newSection = html.querySelector('#product');
          productWrapper.parentNode.replaceChild(newSection, productWrapper);
          document.querySelector(`#${event.target.id}`).focus();
        });
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const variantOptions = document.querySelectorAll('.poids__option.variant_option');
  variantOptions.forEach(option => {
    const labelText = option.querySelector('label').textContent.trim();
    if (labelText === '500g') {
      option.style.display = 'none';
    }
  });
});
*/

// ============================================================
// Remise immédiate réelle sur fiche produit (non-filaments) :
// campagnes automatiques (ex. −15 % accessoires/pièces/résines) sondées
// au cas par cas via un panier JETABLE (session anonyme, credentials omis,
// le panier du client n'est jamais touché).
// ============================================================
(function () {
  var box = document.querySelector("[data-auto-promo]");
  if (!box) return;
  var cache = {};

  function currentVariantId() {
    var sel = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return (sel && sel.value) || box.getAttribute("data-variant-id");
  }

  function fmt(cents) {
    return (cents / 100).toFixed(2).replace(".", ",") + " €";
  }

  function render(it) {
    if (!it || !(it.original_price > it.final_price)) {
      box.hidden = true;
      return;
    }
    var vf = window.vatFactor || 1.2;
    var pct = Math.round(((it.original_price - it.final_price) * 100) / it.original_price);
    box.innerHTML =
      '🏷️ <strong>−' + pct + " % de Remise immédiate</strong> appliquée au panier : " +
      "<strong>" + fmt(Math.round(it.final_price * vf)) + " TTC</strong> " +
      '<span class="auto-promo-ht">(' + fmt(it.final_price) + " HT)</span>" +
      " au lieu de <s>" + fmt(Math.round(it.original_price * vf)) + "</s>";
    box.hidden = false;
  }

  function refresh() {
    var id = currentVariantId();
    if (!id) return;
    if (cache[id]) { render(cache[id]); return; }
    fetch("/cart/add.js", {
      method: "POST",
      credentials: "omit",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var it = data.items ? data.items[0] : data;
        if (!it || it.final_price == null) return;
        cache[id] = it;
        render(it);
      })
      .catch(function () {});
  }

  document.addEventListener("change", function (e) {
    if (e.target && e.target.name === "id") setTimeout(refresh, 60);
  });
  refresh();
})();
